import { ProtectedRoute } from '@/components/shared/ProtectedRoute'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_protected')({
    component: RouteComponent,
})

function RouteComponent() {
    return (
        <ProtectedRoute>
            <Outlet />
        </ProtectedRoute>
    );
}
